export default "__VITE_ASSET__BFSFJb4e__"